import { PromoCodeController } from '../controllers/promoCodeController';
import templateUrl from './promoCodeTemplate.html';
import './promoCode.scss';

export const PromoCodeComponent = {
    templateUrl,
    controller: PromoCodeController
};
